import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import CONSTANTS from 'src/app/app.config';

import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

  form: FormGroup;
  private formSubmitAttempt: boolean;
  logo: string = CONSTANTS.LOGO_PATH
  private returnUrl: string;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    if (localStorage.getItem('currentUser')) {
      this.router.navigate(['/home']);
    }

    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    // get return url from route parameters or default to '/home'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
  }

  onSubmit() {
    if (this.form.valid) {
      this.authService.login(this.form.value)
        .subscribe(() => {
        
        
          let returnTo = [this.returnUrl];

          if (!localStorage.getItem('currentUser')) {
            returnTo = ['/login'];
          }

          let currentUser = JSON.parse(localStorage.getItem('currentUser'));

          if (localStorage.getItem('currentUser') && currentUser.userData.type != 1 ) {
            returnTo = ['/login'];
            localStorage.removeItem('currentUser');
          }
         
          this.router.navigate(returnTo);
        });
    }
    this.formSubmitAttempt = true;
  }
}
